// Cache sprite karakter (NPC) bersama untuk warga trotoar (movers.js) & aktivitas gedung (aktivitas.js):
// paintCode karakter dieksekusi sekali per (aset, arah, zoom-bucket, malam, fase langkah) lalu hanya di-blit.
import { paintBuildingAt } from "./paint";
import { bolehLukis, createLruSprite } from "./lruSprite";

export const NPC_SPRITE_MAX_ZOOM = 1.6;
const spriteCache = createLruSprite(28e6); // ≈28 MB bitmap; LRU + anggaran per frame (lruSprite.js) — tanpa clear massal yang menghentak

export function getNpcSprite(def, dir, zoom, night, t, seed) {
  const zb = Math.round(zoom * 20) / 20;
  const nb = night > 0.4 ? 1 : 0;
  const tb = Math.floor(((t + seed * 0.37) * 8) % 16); // 16 fase langkah @ 8 fps
  const prefix = `${def.bid}|${dir}|${nb}|${tb}|`, key = prefix + zb;
  let sp = spriteCache.get(key);
  if (sp) return sp;
  if (!bolehLukis()) {
    const dekat = spriteCache.nearest(prefix, zb);
    if (dekat) return { cv: dekat.cv, size: dekat.size * zb / dekat.zb };
  }
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const size = Math.ceil(48 * zb), cv = document.createElement("canvas");
  cv.width = cv.height = Math.max(1, Math.ceil(size * dpr));
  const g = cv.getContext("2d");
  g.scale(dpr, dpr);
  paintBuildingAt(g, { ...def, category: "Karakter" }, size / 2, size * 0.78, zb, { time: tb / 8 + seed * 0.37, night: nb ? 1 : 0, dir });
  sp = { cv, size, zb };
  spriteCache.set(key, sp);
  return sp;
}

// Gambar satu NPC di titik layar (sx,sy) — sprite bila zoom kecil, lukis langsung bila zoom dekat
export function blitNpc(g, def, sx, sy, zoom, night, t, seed, dir, alpha = 1) {
  g.save();
  if (alpha < 1) g.globalAlpha = alpha;
  if (zoom <= NPC_SPRITE_MAX_ZOOM) {
    const sp = getNpcSprite(def, dir, zoom, night, t, seed);
    g.drawImage(sp.cv, sx - sp.size / 2, sy - sp.size * 0.78, sp.size, sp.size);
  } else {
    paintBuildingAt(g, { ...def, category: "Karakter" }, sx, sy, zoom, { time: t + seed * 0.37, night, dir });
  }
  g.restore();
}
